module.exports = __webpack_public_path__ + "img/gzhlwfy_position_img.6cc8de2b.png";